import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TestCallPage from './pages/TestCallPage';
import TestChatPage from './pages/TestChatPage';
import ConversationsPage from './pages/ConversationsPage';
import ConversationDetailPage from './pages/ConversationDetailPage';
import SettingsPage from './pages/SettingsPage';
import BusinessesPage from './pages/BusinessesPage';
import AgentsPage from './pages/AgentsPage';
import BusinessSettingsPage from './pages/BusinessSettingsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="test-call" element={<TestCallPage />} />
        <Route path="test-chat" element={<TestChatPage />} />
        <Route path="conversations" element={<ConversationsPage />} />
        <Route path="conversations/:id" element={<ConversationDetailPage />} />
        <Route path="businesses" element={<BusinessesPage />} />
        <Route path="businesses/:businessId/agents" element={<AgentsPage />} />
        <Route path="businesses/:businessId/settings" element={<BusinessSettingsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

